// extracted by css-extract-rspack-plugin
export default {"box":"PUe4Kpm8CScdypEU","heading":"HFCm6VBk8pw9Qrbt","description":"tuZBGA60iBElhB4H","link":"KXTnc6IzMl8ZYODF"};